import { Button } from 'react-bootstrap';
import MaterialIcon from 'material-icons-react';

const LoteModal = ({
    show,
    onClose,
    rowModalData,
    numLotes,
    setNumLotes,
    lotesQtd,
    setLotesQtd,
    lotesCustomizados,
    setLotesCustomizados,
    analisarTotalPecasArr,
    setAnalisarTotalPecasArr,
    showMainLancamentoModal,
    mainLancamentoRowData,
    setMainLancamentoRowData,
    setMainData,
    setAnalisesPeca,
    setDefeitosGrid,
    setLotesOpcoes,
    setShowMainLancamentoModal,
    patchLotesPecas,
    carregarStatus,
    fetchAnalisePecas,
    fetchDefeitosPecas,
    continuarLotesPecas,
    buscarLotesNumericosPorId,
    retornaPecasDoLote,
    styles
}) => {
    if (!show) return null;

    const handleSaveClick = async () => {
        if (!rowModalData) return;
        
        const idMpTriangulacaoRev = rowModalData.idMpTriangulacaoRev;
        const pedido = rowModalData.pedido;
        
        // Estado para analisarTotalPecasArr
        if (typeof setAnalisarTotalPecasArr === 'undefined') {
            window.analisarTotalPecasArr = Array(numLotes).fill(0);
        }
        
        const payload = [];
        for (let idx = 0; idx < numLotes; idx++) {
            const lote = idx + 1;
            const loteCustomizado = lotesCustomizados[idx] || '';
            const qtdePecas = Number(lotesQtd[idx]) || 0;
            const analisarTotalPecas = analisarTotalPecasArr && analisarTotalPecasArr[idx] ? 1 : 0;
            const item = {
                idMpTriangulacaoRev,
                pedido,
                lote,
                loteCustomizado,
                qtdePecas,
                analisarTotalPecas
            };
            // Adiciona `pecasParaRevisao` apenas no botão 'Atualizar'
            if (showMainLancamentoModal) {
                item.pecasParaRevisao = lotesQtd.map((qtd, index) => ({ id: index + 1, quantidade: qtd }));
            }
            payload.push(item);
        }
        
        // Não limpar analisarTotalPecasArr aqui, será atualizado após buscar do backend
        setLotesQtd([]);
        setLotesCustomizados([]);

        if (showMainLancamentoModal) {
            // PATCH para Atualizar
            await patchLotesPecas(payload);
            await carregarStatus();
            // Buscar análises e defeitos atualizados do backend
            if (mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev) {
                const id = mainLancamentoRowData.idMpTriangulacaoRev;
                // Buscar análises
                fetchAnalisePecas(id).then(data => {
                    setAnalisesPeca(data);
                });
                // Buscar defeitos
                fetchDefeitosPecas(id).then(data => {
                    setDefeitosGrid(data);
                });
            }
        } else {
            // POST para Continuar
            await continuarLotesPecas(payload);
        }
        
        setMainData(prev => {
            const novo = prev.map(row =>
                row.idMpTriangulacaoRev === idMpTriangulacaoRev
                    ? { ...row, ehPreLancamento: false || 0, LotesPecas: payload }
                    : row
            );
            return novo;
        });
        
        // Atualiza o loteCustomizado no grid de análises e defeitos imediatamente
        setAnalisesPeca(prev => prev.map(a => {
            const loteAtualizado = payload.find(l => String(l.lote) === String(a.lote));
            if (loteAtualizado && loteAtualizado.loteCustomizado !== undefined) {
                return { ...a, loteCustomizado: loteAtualizado.loteCustomizado };
            }
            return a;
        }));
        
        setDefeitosGrid(prev => prev.map(d => {
            const loteAtualizado = payload.find(l => String(l.lote) === String(d.lote));
            if (loteAtualizado && loteAtualizado.loteCustomizado !== undefined) {
                return { ...d, loteCustomizado: loteAtualizado.loteCustomizado };
            }
            return d;
        }));
        
        // Atualiza lotesOpcoes do modal principal, se ele estiver aberto
        if (showMainLancamentoModal && mainLancamentoRowData && mainLancamentoRowData.idMpTriangulacaoRev === idMpTriangulacaoRev) {
            const lotes = await buscarLotesNumericosPorId(idMpTriangulacaoRev);
            setLotesOpcoes(lotes);
            if (payload.length > 0) {
                const primeiroLote = String(payload[0].lote);

                // monta o array de flags de "analisarTotalPecas"
                const analisarTotalArr = payload.map(l => l.analisarTotalPecas ? 1 : 0);

                // Usa mainLancamentoRowData.LotesPecas ou payload formatado corretamente
                const lotesParaCalculo = mainLancamentoRowData?.LotesPecas || payload.map(p => ({
                    lote: p.lote,
                    qtdePecas: p.qtdePecas
                }));
                
                // agora passa esse array na função
                const pecas = retornaPecasDoLote(lotesParaCalculo, payload[0].lote, analisarTotalArr);

                const novaPeca = pecas.length > 0 ? String(pecas[0]) : '';

                // Soma das quantidades dos lotes para atualizar QTDE PEÇAS
                const somaQtdePecas = payload.reduce((acc, curr) => acc + (Number(curr.qtdePecas) || 0), 0);

                // Buscar novamente os lotes/peças do backend para garantir sincronização dos IDs
                import('../../../services/api').then(({ api }) => {
                    api.get(`/mp/triangulacao-revisao/pedidos/lotes/pecas/id/${mainLancamentoRowData.idMpTriangulacaoRev}`)
                        .then(res => {
                            const lotesPecas = Array.isArray(res.data) ? res.data : res.data.rows;
                            if (Array.isArray(lotesPecas) && lotesPecas.length > 0) {
                                setMainLancamentoRowData(prev => {
                                    if (!prev) return prev;
                                    return {
                                        ...prev,
                                        lote: primeiroLote,
                                        peca: novaPeca,
                                        idMpTriangulacaoRevLotesPecas: lotesPecas[0].idMpTriangulacaoRevLotesPecas,
                                        LotesPecas: lotesPecas,
                                        qtdePecas: somaQtdePecas // Atualiza o valor renderizado
                                    };
                                });
                                setAnalisarTotalPecasArr(lotesPecas.map(l => l.analisarTotalPecas ? 1 : 0));
                            }
                        });
                });
            }
        }
        
        onClose();
        
        // Se não estiver no modal principal, abrir o modal principal com os dados atualizados
        if (!showMainLancamentoModal) {
            // Lógica para sugerir statusRevisao
            let statusRevisao = 'reprovado'

            const tipoTecido = rowModalData?.tipoTecido;

            let indiceTonalidade = null;
            if (payload && payload.length > 0 && payload[0].indicesModalTonalidade && payload[0].indicesModalTonalidade.length > 0) {
                indiceTonalidade = String(payload[0].indicesModalTonalidade[0].indice);
            }

            if (tipoTecido === 'tinto') {
                if (['4/5', '5'].includes(indiceTonalidade)) statusRevisao = 'aprovado';
            } else if (tipoTecido === 'estampado') {
                if (['4', '4/5', '5'].includes(indiceTonalidade)) statusRevisao = 'aprovado';
            }
            
            setMainLancamentoRowData({
                ...rowModalData,
                LotesPecas: payload,
                ehPreLancamento: false,
                statusRevisao
            });
            setShowMainLancamentoModal(true);
        }
    };

    const handleNumLotesChange = (e) => {
        let val = e.target.value.replace(/\D/g, '');
        if (val === '') {
            setNumLotes(0);
            setLotesQtd([]);
            return;
        }
        const n = parseInt(val, 10);
        setNumLotes(n);
        setLotesQtd(prev => {
            const arr = Array.isArray(prev) ? prev : [];
            if (arr.length < n) {
                return [...arr, ...Array(n - arr.length).fill('')];
            } else if (arr.length > n) {
                return arr.slice(0, n);
            } else {
                return arr;
            }
        });
    };

    const handleLoteCustomizadoChange = (idx, value) => {
        setLotesCustomizados(prev => {
            const newLotes = [...prev];
            newLotes[idx] = value;
            return newLotes;
        });
    };

    const handleQtdePecasChange = (idx, e) => {
        setLotesQtd(prev => {
            const newLotes = [...prev];
            let val = e.target.value.replace(/\D/g, '');
            if (val === '' || val === '0') {
                newLotes[idx] = '';
            } else {
                newLotes[idx] = String(Number(val));
            }
            return newLotes;
        });
    };

    const handleAnaliseToggle = (idx) => {
        setAnalisarTotalPecasArr(prev => {
            const arr = [...prev];
            arr[idx] = arr[idx] === 1 ? 0 : 1;
            return arr;
        });
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.loteModalBox}>
                <button
                    className={styles.modalCloseBtn}
                    onClick={onClose}
                    aria-label="Fechar"
                    type="button"
                >
                    ×
                </button>

                <div className={styles.loteTitle}>
                    Atualize a quantidade de lotes caso seja necessário
                </div>
                
                <div className={styles.loteHeader}>
                    <label>
                        QUANTOS LOTES TEM NESSE PEDIDO ?
                        {rowModalData && rowModalData.pedido ? (
                            <span style={{ fontWeight: 400, fontSize: '1rem', marginLeft: 8 }}>
                                ({rowModalData.pedido})
                            </span>
                        ) : null}
                    </label>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className={styles.modalDateInput}
                        style={{ MozAppearance: 'textfield', WebkitAppearance: 'none', appearance: 'none' }}
                        value={numLotes === 0 ? '' : numLotes}
                        onChange={handleNumLotesChange}
                        autoComplete="off"
                    />
                </div>

                <div
                    style={numLotes > 5 ? {
                        display: 'block',
                        maxHeight: 360,
                        overflowY: 'auto',
                        paddingRight: 8,
                        marginBottom: 8,
                        borderBottom: '1px solid #eee',
                        borderTop: '1px solid #eee',
                        marginTop: 8
                    } : {}}
                >
                    {Array.from({ length: numLotes }, (_, idx) => {
                        const value = lotesQtd[idx] !== undefined ? lotesQtd[idx] : '';
                        const isInvalid = !value || isNaN(Number(value)) || Number(value) < 1;
                        return (
                            <div key={idx} className={styles.loteInputGroup} style={{ marginBottom: 25 }}>
                                <div className={styles.modalDateRow}>
                                    <div className={styles.modalDateLabelBox}>Lote {idx + 1}:</div>
                                    <input
                                        type="text"
                                        className={styles.modalDateInput}
                                        value={lotesCustomizados[idx] || ''}
                                        onChange={e => handleLoteCustomizadoChange(idx, e.target.value)}
                                        placeholder="Digite o nome do lote"
                                    />
                                </div>
                                <div className={styles.modalDateRow} style={{ marginTop: 8, display: 'flex', alignItems: 'center' }}>
                                    <div className={styles.modalDateLabelBox}>Quantidade de peças:</div>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        className={styles.modalDateInput + (isInvalid ? ' is-invalid' : '')}
                                        value={lotesQtd[idx]}
                                        onChange={e => handleQtdePecasChange(idx, e)}
                                        style={{ MozAppearance: 'textfield', WebkitAppearance: 'none', appearance: 'none', marginRight: 8 }}
                                    />

                                    <span style={{ fontWeight: 'bold', marginLeft: 12, marginRight: 8 }}>Análise 100%</span>
                                    <span
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                        onClick={() => handleAnaliseToggle(idx)}
                                    >
                                        <MaterialIcon
                                            key={analisarTotalPecasArr[idx]}
                                            icon={analisarTotalPecasArr[idx] === 1 ? "toggle_on" : "toggle_off"}
                                            color={analisarTotalPecasArr[idx] === 1 ? "#218838" : "#202D3B"}
                                            size={28}
                                        />
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <Button
                    className={styles.modalBtn}
                    disabled={
                        numLotes === 0 ||
                        lotesQtd.length !== numLotes ||
                        lotesQtd.some(q => !q || isNaN(Number(q)) || Number(q) < 1)
                    }
                    onClick={handleSaveClick}
                >
                    {showMainLancamentoModal ? 'Atualizar' : 'CONTINUAR'}
                </Button>
            </div>
        </div>
    );
};

export default LoteModal;